// extracted by mini-css-extract-plugin
module.exports = {"chartWrapper":"Chart_chartWrapper__27Trc","chart":"Chart_chart__21AJE","second":"Chart_second__1JaMi"};